import React from "react";

import {SubText} from "@luminate/luminate-native-components";

export const DefaultSchedulingTests = () => {
    return (
        <SubText>No appointment is needed.</SubText>
    );
};
